export default __webpack_public_path__ + "static/media/casualHeadshot.6a8acbe7.81dc7a7f.jpg";